import type { FC } from 'react'
import { useState } from 'react'

import VerifyButton from '@/components/VerifyButton'
import type { CompanyDetails } from '@/types/Activity'

import VerifyOrganisationCreditSidebar from './Sidebar'

interface Props {
  customerId: string
  subjectId: string
  company: CompanyDetails
}

const VerifyOrganisationCredit: FC<Props> = ({ customerId, subjectId, company }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <VerifyOrganisationCreditSidebar
          customerId={customerId}
          subjectId={subjectId}
          credit={company.credit}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <VerifyButton
        onClick={() => setIsSidebarOpen(true)}
        disabled={company?.verification?.verifiedBy === undefined}
      />
    </>
  )
}

export default VerifyOrganisationCredit
